// Espelho de App\Services\ProductNameService (api-mapavendas).
//
// O Mapa de Vendas devolve os kits com a nomenclatura antiga ("Convite Luxo"),
// enquanto a proposta e o contrato fechado usam a comercial
// ("Convite Premium (Luxo)") — que é a que o StartContractJob grava em
// item.produto. Ao vincular um orçamento por aqui o nome precisa passar pelo
// mesmo mapa, senão o item entra com o nome antigo e a comparação com o que já
// está no contrato não casa, duplicando os itens.
//
// Qualquer alteração aqui precisa ser refletida no ProductNameService.

const MAPA_NOMES = [
  ['Convite Luxo', 'Convite Premium (Luxo)'],
  ['Capa Dura', 'Capa Rígida'],
  ['Simples Tipo Folder Personalizado', 'Folder Exclusive'],
  ['Simples Tipo Folder Padrão', 'Folder Exclusive'],
  ['Convite Simples sem Embalagem', 'Folder Exclusive sem Embalagem'],
  ['Convite Simples com Embalagem', 'Folder Exclusive com Embalagem'],
  ['Convite Simples com Luva', 'Convite Exclusive com Luva'],
  ['Convite Semiluxo', 'Convite Classic'],
  ['Capa Mole', 'Capa Flexível'],
  ['Luva Semi Luxo', 'Luva Classic (Semi Luxo)'],
  ['Luva Simples', 'Luva Exclusive (Simples)'],
  ['Luva Luxo', 'Luva Premium (Luxo)'],
  ['Caixa Padrão', 'Caixa Premium'],
];

// Converte o nome vindo do Mapa de Vendas no nome comercial. É idempotente:
// nenhum nome comercial contém a chave que o gerou, então aplicar o mapa num
// nome já convertido devolve o mesmo texto — por isso serve tanto para gravar
// quanto para comparar com itens antigos.
export function renomearProduto(texto) {
  if (!texto) {
    return "";
  }

  let nome = String(texto);

  MAPA_NOMES.forEach(([de, para]) => {
    nome = nome.split(de).join(para);
  });

  // "... (Aproveitamento de 2) 22X30" -> remove o tamanho no final
  nome = nome.replace(/\)\s+\d+[Xx]\d+\s*$/i, ")");
  // Remove "(aproveitamento de N)" de qualquer posição
  nome = nome.replace(/\s*\(\s*aproveitamento\s+de\s+\d+\s*\)/gi, "");
  // Remove "(revestimento e acabamento N cores)" de qualquer posição
  nome = nome.replace(/\s*\(revestimento e acabamento\s*\d*\s*cores?\)/gi, "");

  return nome;
}

export default renomearProduto;



// WEBPACK FOOTER //
// ./src/services/nomesProdutos.js